import * as React from 'react';

function SvgCreditCard(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path d="M20.7 3c1.75 0 3.19 1.47 3.3 3.32v11.15c0 1.88-1.37 3.41-3.1 3.52l-.2.01H3.3C1.55 21 .11 19.53 0 17.68V6.53c0-1.88 1.37-3.41 3.1-3.52L3.3 3h17.4zM2 11v6.47c0 .8.58 1.44 1.32 1.52l.15.01h17.06c.76 0 1.39-.6 1.46-1.37l.01-.16V11H2zm17.06 4c.52 0 .94.45.94 1a1 1 0 01-.81 1h-3.25c-.52 0-.94-.45-.94-1a1 1 0 01.81-1h3.25zM3.47 5c-.76 0-1.39.66-1.46 1.5v.18L2 9h20V6.68c0-.87-.58-1.59-1.32-1.67L20.53 5H3.47z" />
    </svg>
  );
}

export default SvgCreditCard;
